import { useEffect, useState } from 'react';
import { getSchoolMeta, updateSchoolMeta } from '../../utils/functions';

export function MetaText(props) {
    const [editOpen, setEditOpen] = useState(false);
    const [textValue, setTextValue] = useState('');
    const [newTextValue, setNewTextValue] = useState('');
    useEffect(() => {
        const getAndSetSchoolMeta = async () => {
            const schoolMeta = await getSchoolMeta(props.schoolId, props.metaKey);
            setTextValue(schoolMeta.data);
        };
        getAndSetSchoolMeta();
    }, []);

    const onClickSave = async () => {
        await updateSchoolMeta(props.schoolId, props.metaKey, { value: newTextValue });
        setEditOpen(false);
        setTextValue(newTextValue);
    };

    const onClickCancel = () => {
        setEditOpen(false);
        setNewTextValue(textValue);
    };

    const onClickEdit = () => {
        setNewTextValue(textValue);
        setEditOpen(true);
    };
    return (
        <>
            {editOpen ? (
                <div className={'metatext-edit edit-form'}>
                    <textarea value={newTextValue} onChange={(event) => setNewTextValue(event.target.value)} />
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button onClick={onClickSave}>Save</button>
                        <button onClick={onClickCancel}>Cancel</button>
                    </div>
                </div>
            ) : (
                <div className={'metatext edit-form'}>
                    <p className={'metatext'}>{textValue}</p>
                    {props.role === 'admin' && <button onClick={onClickEdit}>Edit</button>}
                </div>
            )}
        </>
    );
}
